function determinePreviewImagePrintDetails(printPositions, category, side = 'front', gender = 'mens') {
  let printType = 'text';
  let printPositionObject = printPositions[side][gender].fullFront;

  switch (category) {
    case 'sports':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].fullFront;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'work':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'school':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'events':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].fullFront;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'tees':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].fullFront;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'hoodies':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'polos':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'singlets':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    case 'jackets':
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].leftChest;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
    default:
      if (side === 'front') {
        printType = 'logo';
        printPositionObject = printPositions[side][gender].fullFront;
      }
      if (side === 'back') {
        printType = 'roster';
        printPositionObject = printPositions[side][gender].nameAndNumber;
      }
      break;
  }

  if (!printPositionObject) {
    return {
      printType,
      printPosition: null,
    };
  }

  const printPosition = printPositionObject.label.replaceAll(' ', '-').toLowerCase();

  return {
    printType,
    printPosition,
  };
}

export default determinePreviewImagePrintDetails;
